import { render } from "./ModalVacunas.vue?vue&type=template&id=6a02e0aa&scoped=true"
import script from "./ModalVacunas.vue?vue&type=script&lang=js"
export * from "./ModalVacunas.vue?vue&type=script&lang=js"

import "./ModalVacunas.vue?vue&type=style&index=0&id=6a02e0aa&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a02e0aa"]])

export default __exports__